import styled, { keyframes } from 'styled-components'

function Percentage({ percent }) {
    return (
        <Percent>
            <svg viewBox="0 0 36 36" className="circular-chart">
                <path
                    className="circle-bg"
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                    className="circle"
                    strokeDasharray={`${percent < 0 ? 0 : percent},100`}
                    d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <text x="18" y="20.35" className="percentage">
                    {`${percent}%`}
                </text>
            </svg>
        </Percent>
    )
}

const progress = keyframes`
from {
    stroke-dasharray: 0 100;
  }
`

const Percent = styled.div`
    width: 100%;
    justify-content: space-around;
    background: #2e2e53;
    box-shadow: -3px 3px 6px rgba(22, 22, 39, 0.2),
        3px -3px 6px rgba(22, 22, 39, 0.2), -3px -3px 6px rgba(70, 70, 127, 0.9),
        3px 3px 8px rgba(22, 22, 39, 0.9),
        inset 1px 1px 2px rgba(70, 70, 127, 0.3),
        inset -1px -1px 2px rgba(22, 22, 39, 0.5);
    padding: 1px;
    border-radius: 50%;
    aspect-ratio: 1;
    max-width: 100px;
    margin: auto;

    .circular-chart {
        display: block;
        margin: 10px auto;
        max-width: 80%;
        max-height: 250px;
    }

    .circle-bg {
        fill: none;
        stroke: #2e2e53;
        stroke-width: 3.8;
    }

    .circle {
        fill: none;
        stroke-width: 3.5;
        stroke-linecap: round;
        stroke: #00e3ae;
        animation: ${progress} 1s ease-out forwards;
    }

    .percentage {
        fill: #00e3ae;
        font-weight: 600;
        font-size: 0.5em;
        text-anchor: middle;
    }
`

export default Percentage
